/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_vol_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A US cup is 236.588 mL, commonly rounded to 240 mL on nutrition labels. That rounding is intentional for label consistency, not an error — for precise cooking or scientific measurement, use the unrounded 236.588 mL figure this converter gives you.`)
};

const es_uc_vol_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una taza estadounidense es 236.588 mL, comúnmente redondeada a 240 mL en etiquetas de nutrición. Ese redondeo es intencional para consistencia de etiqueta, no un error — para medida de cocina o científica precisa, usa la figura no redondeada 236.588 mL que este conversor te da.`)
};

const de_uc_vol_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein US-Cup sind 236.588 mL, auf Nährwertangaben meist auf 240 mL gerundet. Diese Rundung ist für die Konsistenz der Etiketten beabsichtigt, kein Fehler — für präzises Kochen oder wissenschaftliche Messungen verwenden Sie den ungerundeten Wert von 236.588 mL, den dieser Umrechner liefert.`)
};

const nl_uc_vol_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een Amerikaanse kopje is 236.588 mL, veel voorkomend afgerond naar 240 mL op voedingslabels. Die afronding is opzettelijk voor labeleenheidsconsistentie, geen fout — voor nauwkeurig koken of wetenschappelijke meting, gebruik de niet-afgeronde 236.588 mL figuur deze convertor geeft u.`)
};

const fr_uc_vol_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une tasse américaine est 236,588 mL, couramment arrondie à 240 mL sur les étiquettes nutritionnelles. Cet arrondi est intentionnel pour la cohérence d'étiquetage, pas une erreur — pour une cuisine précise ou une mesure scientifique, utilisez le chiffre non arrondi de 236,588 mL que ce convertisseur vous donne.`)
};

const it_uc_vol_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una tazza USA è 236,588 mL, comunemente arrotondata a 240 mL sulle etichette nutrizionali. Questo arrotondamento è intenzionale per la coerenza dell'etichetta, non un errore — per la cucina precisa o la misurazione scientifica, usa la figura non arrotondata di 236,588 mL che questo convertitore ti fornisce.`)
};

const pt_br2_uc_vol_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma xícara US é 236.588 mL, comumente arredondada para 240 mL em rótulos de nutrição. Esse arredondamento é intencional para consistência de rótulo, não um erro — para culinária precisa ou medição científica, use a figura 236.588 mL não arredondada que este conversor lhe dá.`)
};

const pt_uc_vol_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma chávena americana é 236,588 mL, comummente arredondada para 240 mL nas etiquetas nutricionais. Esse arredondamento é intencional para consistência de etiqueta, não um erro — para cozinha precisa ou medição científica, utilize a figura não arredondada 236,588 mL que este conversor lhe dá.`)
};

const ja_uc_vol_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`米国カップは236.588 mL で、栄養ラベルでは一般に240 mLに丸められています。その丸めはエラーではなく、意図的なもので、ラベルの一貫性のためです — 正確な調理または科学的測定のため、このコンバーターが与える丸められていない236.588 mL の数字を使用します。`)
};

const zh_uc_vol_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_vol_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_vol_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_vol_faq2_a", locale)
	if (locale === "en") return en_uc_vol_faq2_a(inputs)
	if (locale === "es") return es_uc_vol_faq2_a(inputs)
	if (locale === "de") return de_uc_vol_faq2_a(inputs)
	if (locale === "nl") return nl_uc_vol_faq2_a(inputs)
	if (locale === "fr") return fr_uc_vol_faq2_a(inputs)
	if (locale === "it") return it_uc_vol_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_vol_faq2_a(inputs)
	if (locale === "pt") return pt_uc_vol_faq2_a(inputs)
	if (locale === "ja") return ja_uc_vol_faq2_a(inputs)
	return zh_uc_vol_faq2_a(inputs)
};